import API from '../../api';

const types = {
  GET_AGENTS_SUCCESS: 'GET_AGENTS_SUCCESS',
  GET_AGENTS_ERROR: 'GET_AGENTS_ERROR',
}

const state = {
  all: []
}

const getters = {
  byId: state => id => {
    return state.all.find(item => item.id == id);
  },
}

const actions = {
  get({ commit }, params) {
    return API.agents.get(params).then(response => {
      commit(types.GET_AGENTS_SUCCESS, response.data.result);
      return response;
    }).catch(error => {
      commit(types.GET_AGENTS_ERROR);
    });
  },
}

const mutations = {
  [types.GET_AGENTS_SUCCESS](state, issues) {
    state.all = issues;
  },

  [types.GET_AGENTS_ERROR](state) {
    state.all = [];
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
